export default "__VITE_ASSET__DhZoWO4P__"